module.exports = __webpack_public_path__ + "static/images/appointments.1bab9b6988d3205b2e2126b6ffc60eca.svg";